import React, { useContext } from "react";
import { useUserPreference } from "../../Hooks/useUserPreference";
import { SidePaneContext } from "./context";

function SidePane({ children, className = "" }) {
	const { sidePane, notificationsOverride } = useUserPreference();
	const { SidePaneContent } = useContext(SidePaneContext);

	const showCustomContent = SidePaneContent && !notificationsOverride;

	return (
		<div className={`sidepane-wrapper ${sidePane ? "expanded" : "collapsed"}`}>
			<div className={`sidepane ${showCustomContent ? "hide" : "show"} ${className}`}>
				<div className="sidepane-content">{children}</div>
			</div>
			<div className={`sidepane ${showCustomContent ? "show" : "hide"} ${className}`}>
				<div className="sidepane-content">{SidePaneContent}</div>
			</div>
		</div>
	);
}

export default SidePane;
